import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/mfa/user.mfa.addPhone.mutation.gql"
import type {
  UserAddMfaPhoneMutation,
  UserAddMfaPhoneMutationVariables,
} from "@/v2-backoffice-client/user/mfa/__types__/user.mfa.addPhone.mutation"

type Options = MutationHookOptions<
  UserAddMfaPhoneMutation,
  UserAddMfaPhoneMutationVariables
>

export function useUserAddMfaPhoneMutation(options?: Options) {
  return useMutation<UserAddMfaPhoneMutation, UserAddMfaPhoneMutationVariables>(
    mutation,
    options,
  )
}
